import React from "react";

/**
 * SearchNew — search magnifying-glass icon.
 *
 * Matches the client's replacement Search.svg (src/images/Search.svg) so every
 * search field across the site uses the same Figma icon. A unique clipPath id
 * (search-clip-new) avoids colliding with Search.js's "search-clip" when both
 * render on the same page (e.g. header search + a search bar).
 */
const SVG = ({
  style = {},
  stroke = "#6C6C6C",
  width = "24px",
  height,
  className = "",
  viewBox = "0 0 24 24"
}) => (
  <svg
    width={width}
    height={height || width}
    viewBox={viewBox}
    style={style}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <g clipPath="url(#search-clip-new)">
      <path
        d="M9.98375 18.6003C14.6174 18.6003 18.3737 14.844 18.3737 10.2103C18.3737 5.57665 14.6174 1.82031 9.98375 1.82031C5.35008 1.82031 1.59375 5.57665 1.59375 10.2103C1.59375 14.844 5.35008 18.6003 9.98375 18.6003Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9938 16.3603L22.6038 22.9703"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="search-clip-new">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
